import { render } from "./VariantsContributors.vue?vue&type=template&id=7eb9783e&ts=true"
import script from "./VariantsContributors.vue?vue&type=script&lang=ts"
export * from "./VariantsContributors.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__